import { render } from "./PosPreviewReceipt.vue?vue&type=template&id=df7489aa&scoped=true&ts=true"
import script from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"

import "./PosPreviewReceipt.vue?vue&type=style&index=0&id=df7489aa&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7489aa"]])

export default __exports__